import { get } from 'lodash';
import { RootState } from 'store';
import { useAppSelector } from 'store/hooks';
import { IDEMOModelResDataItem } from '../interfaces/demoData';
import { IChannelState, ILayoutItem } from '../interfaces/api';
/**
 * please change reducer name
 */
// @ts-ignore
type MyState = RootState['channel']; // ex: RootState['booking']
// @ts-ignore
const getCurrentState = (state: RootState): MyState => state['channel']; // ex: state['booking']

const selector = <T = MyState>(key: keyof T, defaultValue?: any) => useAppSelector(state => get(getCurrentState(state), key, defaultValue));

const getDemoData = () => selector('demoData') as IDEMOModelResDataItem[];

const getListChannels = () => selector('dataChannels') as IChannelState;

const getListLayouts = () => selector('dataLayouts') as ILayoutItem[];
/**
 * please replace channel to your feature name
 * ex:
 * channelSelectors => bookingSelectors
 */
const channelSelectors = {
  getDemoData,
  getListChannels,
  getListLayouts,
};
export default channelSelectors;
